// extracted by css-extract-rspack-plugin
export default {"trustpilot":"footer-fragment__Trustpilot_trustpilot__1yD1c"};